module.exports = __webpack_public_path__ + "media/images/logo-6e544cf8232eed433e00ff8dcc812c90.jpg";